module.exports = __webpack_public_path__ + "a5002963b0570a073e28156403c78670.woff";


//////////////////
// WEBPACK FOOTER
// ./application/font/SourceSansPro-Light.woff
// module id = 359
// module chunks = 0